var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLoader = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "loader_svg__gooey"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 10,
  result: "blur"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "blur",
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 18 -7",
  result: "goo"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "goo"
})))));
export default __webpack_public_path__ + "static/loader.[git-hash].svg";
export { SvgLoader as ReactComponent };